import React, { FC } from 'react'
import { useLocation } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';

import { OverlayTrigger, Tooltip } from 'react-bootstrap'

import { Link } from 'react-router-dom'

import { Logo } from '../components/Logo'

import {useLang} from '../../_metronic/i18n/Metronici18n'

import { UserMenuDropdown } from '../components/UserMenuDropdown'

import {useLayout} from '../context/layout'

import { useAuth } from '../context/auth';
import { UserType } from '../models';

import { useIntl } from 'react-intl'

import { useThemeMode } from '../../_metronic/partials/layout/theme-mode/ThemeModeProvider'

import { UserModel } from '../models'

import UserSymbol from '../components/UserPicture'

import { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'

import { chatAPI } from '../../app/api'

import {setTitle} from '../../app/utils'

import {SharedChatModel} from '../../app/models'


const getUserMenuIcon = (currentUser) => {
  if( !currentUser?.email ){
    return <i className="fa-solid fa-circle-question fs-2"></i>
  }else{
    return <UserSymbol picture={currentUser?.picture}  size={30}/>
  }
}

interface ChatMobileHeaderProps {
  currentUser?: UserModel,
  currentSharedChat?: SharedChatModel,
  handleStartNewChat: () => void;
}

const ChatMobileHeader: FC<ChatMobileHeaderProps>  = ({currentUser, currentSharedChat, handleStartNewChat}) => {

  const intl = useIntl()

  const selectedLang = useLang()

  return <div className={`mobile-header z-index-3 d-flex position-relative flex-row py-2 d-lg-none px-0 flex-center align-items-center w-100`}>
    { !currentUser?.email ?
    <button className="btn btn-flex position-absolute start-0 btn-active-light-dark btn-icon" onClick={handleStartNewChat}>
      <i className="fa-solid fa-edit fs-2"></i>
    </button>
    :
    !currentSharedChat && 
    <button className="btn btn-icon position-absolute start-0" id="aside-toggle" >
      <i className="fa-solid fa-bars fs-2"></i>
    </button>
    }
    <div className={currentUser?.email && currentSharedChat ? 'position-absolute start-0 ms-2' : `text-center`}>
      <Logo/>
    </div>
    { currentSharedChat && currentUser?.email &&
      <div className="text-center w-75">
        <div className="text-truncate text-dark fw-bold fs-4">{currentSharedChat.name}</div>
      </div>
    }
    { !currentUser?.email ?
      <div className="position-absolute end-0">
        <Link className="btn btn-primary px-3 py-1 me-2" to="/a/sign-in">
          {intl.formatMessage({id: 'user.sign_in'})}
        </Link>
        <div className="btn btn-active-light-dark btn-icon" data-kt-menu-trigger="{default: 'click', lg: 'hover'}" data-kt-menu-attach="parent" data-kt-menu-placement={`top-${selectedLang == 'en' ? 'end' : 'start'}`}>
          {getUserMenuIcon(currentUser)}
        </div>
        <UserMenuDropdown/>
      </div>
    :
    <button className="btn btn-icon start-new-chat position-absolute end-0" onClick={handleStartNewChat}>
      <i className="fa-solid fa-edit fs-2"></i>
    </button>
  }
</div>
}


interface ChatContentProps {
  children: React.ReactNode;
  handleStartNewChat: () => void;
}

const ChatContent: FC<ChatContentProps> = ({children, handleStartNewChat}) => {

  const location = useLocation()

  const isSharedChat = location.pathname.includes('/s/')

  const { showAside, toggleAside } = useLayout();
  
  const {currentUser} = useAuth()

  const intl = useIntl()

  const isMobile = useMediaQuery({ maxWidth: 991.98 });

  const {mode} = useThemeMode()

  const selectedLang = useLang()


  return <div className="d-flex flex-column overflow-hidden align-items-center position-relative p-2 flex-row-fluid"  style={mode == 'light' ? {} : {
    backgroundImage :"url('/images/main-background.png')",
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
  }}>
    { !isSharedChat && currentUser?.email &&
    <OverlayTrigger
      placement='bottom'
      overlay={<Tooltip>{intl.formatMessage({id: showAside ? 'general.close_sidebar' : 'general.open_sidebar' })}</Tooltip>}
    >
      <div className="position-absolute  d-none d-lg-flex  top-0 ms-4 mt-4 start-0 z-index-1">
        <div className="btn btn-flex btn-active-light-dark btn-icon" onClick={()=>toggleAside()}>
          <i className="fa-solid fa-bars fs-2"></i>
        </div>
      </div>
    </OverlayTrigger>
    }

    {!isSharedChat && (!showAside || !currentUser?.email) && (
      <OverlayTrigger
        placement='bottom'
        overlay={<Tooltip>{intl.formatMessage({id: 'chat.new' })}</Tooltip>}
      >
        <div className={`position-absolute d-none d-lg-flex top-0 ${!currentUser?.email ? "ms-4" : "ms-17"} mt-4 start-0 z-index-1`}>
          <button className="btn btn-flex btn-active-light-dark mb-1 btn-icon" onClick={handleStartNewChat}>
            <i className="fa-solid fa-edit fs-2"></i>
          </button>
        </div>
      </OverlayTrigger>
    )}

    {isSharedChat && 
     <div className={`position-absolute d-none d-lg-flex top-0 ms-4 mt-4 start-0 z-index-1`}>
       <Link className="btn btn-flex btn-active-light-dark mb-1 btn-icon" to="/c">
        <Logo size={25}/>
       </Link>
     </div>
    }

    {
      !isMobile && 
      <div className="position-absolute top-0 me-4 mt-4 end-0 z-index-1">
        { !currentUser?.email &&
        <Link className="btn btn-primary me-4" to="/a/sign-in">
          {intl.formatMessage({id: 'user.sign_in'})}
        </Link>
        }
        <div className="btn btn-flex btn-active-light-dark btn-icon" data-kt-menu-trigger="{default: 'click', lg: 'hover'}" data-kt-menu-attach="parent" data-kt-menu-placement={`top-${selectedLang == 'en' ? 'end' : 'start'}`}>
          {getUserMenuIcon(currentUser)}
        </div>
        <UserMenuDropdown/>
      </div>
    }

    {children}
  </div>
}

export {ChatContent, ChatMobileHeader}